export default function CompanyResults() {
  const results = [
    { icon: 'ri-line-chart-line', title: 'Рост конверсии', desc: 'Качественная переписка удерживает клиента в диалоге и доводит до сделки. Конверсия растёт на каждом этапе воронки.' },
    { icon: 'ri-timer-flash-line', title: 'Быстрые ответы', desc: 'Менеджеры получают инструменты для быстрой и точной реакции. Сокращается время ответа, растёт удовлетворённость клиентов.' },
    { icon: 'ri-file-check-line', title: 'Единый стиль общения', desc: 'Каждый клиент получает стабильно высокий уровень коммуникации. Нет разницы, с кем он общается в переписке.' },
    { icon: 'ri-speed-line', title: 'Ускорение сделки', desc: 'Чёткая структура переписки сокращает цикл сделки. Меньше потерянных сообщений и забытых клиентов.' },
    { icon: 'ri-money-dollar-circle-line', title: 'Рост среднего чека', desc: 'Умение аргументировать ценность в переписке увеличивает средний чек без агрессивных продаж.' },
    { icon: 'ri-user-received-line', title: 'Снижение потери лидов', desc: 'Меньше клиентов уходит после первого сообщения. Системный follow-up возвращает «уснувших» клиентов.' },
    { icon: 'ri-star-line', title: 'Повышение качества сервиса', desc: 'Профессиональная, уважительная и персонализированная переписка формирует сильный клиентский опыт.' },
    { icon: 'ri-bar-chart-grouped-line', title: 'Системная работа менеджеров', desc: 'Продажи перестают зависеть от настроения и интуиции. Появляется система, которая работает стабильно.' },
  ];

  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-teal-50 text-teal-700 px-4 py-2 rounded-full text-sm font-semibold mb-6">
            <i className="ri-bar-chart-grouped-line"></i>
            Бизнес-результаты
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Что получает компания
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Системное обучение продажам через переписку приносит измеримые бизнес-результаты на всех этапах воронки.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {results.map((item, i) => (
            <div key={i} className="bg-gray-50 rounded-xl p-5 md:p-6 border border-gray-100 hover:border-teal-100 hover:bg-teal-50/30 transition-colors group">
              <div className="w-12 h-12 bg-teal-600/10 rounded-xl flex items-center justify-center flex-shrink-0 mb-4 group-hover:bg-teal-600/15 transition-colors">
                <i className={`${item.icon} text-teal-600 text-xl`}></i>
              </div>
              <h3 className="text-base font-semibold text-gray-900 mb-2">{item.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}